import { useState, useEffect } from 'react'
import { Menu } from 'lucide-react'
import Logo from '../Images/LogoMayra.png'
import './Header.css'

function Header({ scrollToSection }) {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth < 1080)
      if (window.innerWidth >= 1080) {
        setIsMenuOpen(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleLinkClick = (e, sectionId) => {
    scrollToSection(e, sectionId);
    setIsMenuOpen(false);
  };

  return (
    <>
      <div className="header-wrapper">
        <header className={`header ${isScrolled ? 'header-scroll' : ''}`}>
          <div className="header-content">
            <div className="logo-container">
              <a href="#inicio" onClick={(e) => handleLinkClick(e, 'inicio')}>
                <img src={Logo} alt="Nut. Mayra Alejandra Martell" className="logo-image" />
                <div className="logo-text">
                  <h1>Mayra Alejandra Martell</h1>
                  <p>Nutricionista Colegiada</p>
                </div>
              </a>
            </div>

            {!isMobile ? (
              <nav className="desktop-nav">
                <ul className="nav-list">
                  <li><a href="#inicio" onClick={(e) => handleLinkClick(e, 'inicio')}>Inicio</a></li>
                  <li><a href="#sobre-mi" onClick={(e) => handleLinkClick(e, 'sobre-mi')}>Sobre Mí</a></li>
                  <li><a href="#servicios" onClick={(e) => handleLinkClick(e, 'servicios')}>Servicios</a></li>
                  <li><a href="#nutrishop" onClick={(e) => handleLinkClick(e, 'nutrishop')}>NutriShop</a></li>
                  <li><a href="#testimonios" onClick={(e) => handleLinkClick(e, 'testimonios')}>Testimonios</a></li>
                  <li><a href="#contacto" onClick={(e) => handleLinkClick(e, 'contacto')}>Contacto</a></li>
                </ul>
              </nav>
            ) : (
              <nav className="mobile-nav">
                <button
                  className="menu-icon"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  aria-label="Toggle menu"
                >
                  <Menu />
                </button>

                {isMenuOpen && (
                  <div className="mobile-menu">
                    <a href="#inicio" onClick={(e) => handleLinkClick(e, 'inicio')}>Inicio</a>
                    <a href="#sobre-mi" onClick={(e) => handleLinkClick(e, 'sobre-mi')}>Sobre Mí</a>

                    <a href="#servicios" onClick={(e) => handleLinkClick(e, 'servicios')}>Servicios</a>

                    <a href="#nutrishop" onClick={(e) => handleLinkClick(e, 'nutrishop')}>NutriShop</a>

                    <a href="#testimonios" onClick={(e) => handleLinkClick(e, 'testimonios')}>Testimonios</a>
                    <a href="#contacto" onClick={(e) => handleLinkClick(e, 'contacto')}>Contacto</a>
                  </div>
                )}
              </nav>
            )}
          </div>
        </header>
      </div>
    </>
  )
}

export default Header